define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/view/PdfRequestController",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,locale,PdfRequestController,MessageDialog,xml) {

	return declare(PdfRequestController, {
		// Boolean: do not wait for action to complete
		bWait: false,

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: initialize fields from user settings
			view.addDefaultValue("Locale", locale.getLocale());
			this.inherited(arguments);
		},

		toWriterRequest: function() {
			// summary: write special request to server passing in PDFRequestURL
			return this.inherited(arguments).addParameter("RequestURL", xml.ATTR_CNL, this._createRequestUrl());
		},

		postProcessSuccess: function() {
			// summary: display error if PDF request not started correctly
			this.widget.redrawNode(this.m_element);
			const node = this.getNode();
			const dataPackageUrl = node.SRLineItemPackage;
			const dataPackageNode = this.m_cache.getNode(dataPackageUrl);

			if(dataPackageNode && !dataPackageNode.UseCoverSheet && !dataPackageNode.DataSheets.length){
				new MessageDialog({
					buttons: [MessageDialog.BUTTON_OK],
					materialIcon: MessageDialog.ICON_WARNING,
					message: locale.resource("DPNoDataSheets_Error"),
					title: locale.resource("WARNING")
				}).show();
				return;
			}

			if (node["PDF.Status"] == undefined && node["File.Status"] == undefined) {
				// The node on which the action was invoked is not necessarily the node that owns
				// the PDFRequest. Check that one, too. (e.g. DE21419, the GenerateProductPDF action
				// on the SupplierRequest.StyleLineItems view)
				var pdfRequest = this.m_cache.getNode(this.urlRequest);
				if (pdfRequest && pdfRequest.Status == "Failed") {
				    new MessageDialog({
				            buttons: [MessageDialog.BUTTON_OK],
				            materialIcon: MessageDialog.ICON_ERROR,
				            message: pdfRequest.StatusMessage,
				            title: locale.resource("ERROR")
				        }).show();
				        return;
	                }
				var pdfRequestContainer = pdfRequest ? this.m_cache.getNode(pdfRequest.__Parent__) : null;
				if (!pdfRequestContainer || pdfRequestContainer["PDF.Status"] == undefined) {
					this._showFailureWarning();
					return;
				}
			}

			this.confirmAction({
				buttons: ["OK"],
				materialIcon: MessageDialog.ICON_INFO,
				onResponse: function() {}
			});
			this.inherited(arguments);
		},

		getString: function(/*String*/suffix, /*String[]?*/params) {
			var s = this.inherited(arguments);
			if (s) return s;

			return locale.resourceIfExists("GeneratePDF" + suffix, params);
		},

		_showFailureWarning: function() {
			this.displayErrorDialog({
				materialIcon: MessageDialog.ICON_WARNING,
				message: this.getString("_Error"),
				title: locale.resource("WARNING"),
				onResponse: false
			});
		}
	});
});